import { LoyaltyChannelService } from './../../../../services/loyalty/loyalty-channel.service';
import { HttpService } from './../../../../modules/UIKit/components/spinnerLoading/httpServ.service';
import { CustomerCardListModel } from './../../../../models/customer-cards.model';
import { CustomerBasicInfo, CustomerLoyaltyInfo } from './../../../../models/customer.model';
import { ActivatedRoute } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { ConfirmationService, SelectItem } from 'primeng/components/common/api';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { CalendarTranslate } from '../../../../models/calendarTranslate.model';
import { mgCustomer } from '../../../../models/customer.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { TranslateService } from '@ngx-translate/core';
import { CountryService } from '../../../../services/country/country.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { ProvinceService } from '../../../../services/province/province.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { LoyaltyCardService } from '../../../../services/loyalty/loyalty-card.service';
import { ToponymService } from '../../../../services/toponym/toponym.service';
import { AutoComplete, InputText } from 'primeng/primeng';
import { AuthService } from '../../../../services/user/auth.service';
import { LoyaltyGiftReservationService } from '../../../../services/loyalty/loyalty-gift-reservation.service';
import { CompileMetadataResolver } from '@angular/compiler';

@Component({
  selector: 'app-customer-basic-new',
  templateUrl: './basicnew.component.html',
  providers: [],
})
export class CustomerDetailBasicNewComponent implements OnInit {

  @Input() customerId: string;
  @Input() cardInfo: Array<CustomerCardListModel>;

  @Output() basicInfoLoaded = new EventEmitter();
  @Output() cardsInfoLoaded = new EventEmitter();
  @Output() dirtyFormData = new EventEmitter();
  @Output() allMandatoryFieldsOkLoaded = new EventEmitter();

  @ViewChild('autocompleteCard') private autocompleteCard: AutoComplete;
  @ViewChild('inputCard') private inputCard: InputText;

  fields: any;
  availableCards: CustomerCardListModel[];
  formData: FormGroup;
  calendarTranslate: CalendarTranslate;
  editMode: boolean;
  code_cards: SelectItem[] = [];
  channels: SelectItem[] = [];
  stores: SelectItem[] = [];
  preferredStores: SelectItem[] = [];
  domiciliationStores: SelectItem[] = [];
  sex: SelectItem[] = [];
  toponyms: SelectItem[] = [];
  country: any = null;
  provinces: SelectItem[] = [];
  maxDate: Date = new Date();
  fiscalCodeDate: Date = null;
  invalidSubmit: boolean;
  cardIdSelected: number;
  cardNoSelected: string;
  storeIdSelected: number;
  basicInfo: CustomerBasicInfo;
  showEmailOrMobileError: boolean = false;
  userId: string;

  validators = {
    fiscalCode: KoncentroValidators.fiscalCode,
    emailOrEmpty: KoncentroValidators.emailOrEmpty,
    phone: KoncentroValidators.phone_mg,
    onlyNumbers: KoncentroValidators.number,
    zipCodeValidator: KoncentroValidators.zipCodeValidator
  }

  constructor(
    private srvCustomer: CustomerInfoService,
    private srvCalendarTranslate: CalendarTranslateService,
    private fb: FormBuilder,
    private srvStoreCommon: StoreCommonService,
    private srvLoyaltyCard: LoyaltyCardService,
    private srvCustomerCard: CustomerCardService,
    private srvLoyaltyGiftReservation: LoyaltyGiftReservationService,
    private translate: TranslateService,
    private srvToponyms: ToponymService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private activatedRoute: ActivatedRoute,
    private srvChannel: LoyaltyChannelService,
    private srvHttp: HttpService,
    private authService: AuthService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {


  /*
    NOTE DI LOGICA:

    Inserimento cliente:
    Se le opzioni della combo puntoVendita hanno un solo record solo allora lo si deve selezionare direttamente.
    Questo record viene fuori dalla lista di negozi a cui l'utente è abilitato.

    Modifica cliente:
    Al differenza dell'inserimento, quì non si considera più il negozio a cui è abilitato l'utente,
    ma la compo del puntoVendita viene popolata con il negozio trovato nella carta.
  */

    this.code_cards = [];
    this.channels = [];
    this.stores = [];
    this.preferredStores = [{value: null, label: ''}];
    this.domiciliationStores = [{value: null, label: ''}];
    this.sex = [{value: null, label: ''}];
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);

    var translateObs = this.translate.get([
      'customerDetail.sex_male',
      'customerDetail.sex_female',
      'customerDetail.sex_other'
    ]);
    this.toponyms = [{value: null, label: ''}];
    this.provinces = [];
    var self = this;

    var CALENDAR = this.srvCalendarTranslate.pCalendar;
    var FIELDS = this.srvCustomer.getMgCustomerFields();
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.editMode = (this.customerId !== undefined);
    let domiciliationStores: Observable<any>;
    let preferredStores: Observable<any>;
    //let divisionStores: Observable<any>;
    let toponyms: Observable<any>;
    let provinces: Observable<any>;

    /***
     * 25/11/2021 non serve più lo userId perchè la combo dei negozi preferiti non deve essere più filtrata per i negozi della divisione, ma devono essere presi tutti i
     * negozi
     *
    */
    /*
    this.userId = this.authService.user.id.toString();
    divisionStores = this.srvStoreCommon.getUserStoresAndSalesNetworks(this.userId);
    */

    //domiciliationStores = this.srvStoreCommon.getList(0,9999);
    domiciliationStores = this.srvStoreCommon.getList(0,9999);
    preferredStores = this.srvStoreCommon.getAllStores(9999);

    toponyms = this.srvToponyms.getAll();
    let search = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];

      var GETBASICINFO = Observable.of(null);
      var COUNTRIES = this.srvCountry.list(null,null,search);

      if (this.editMode) {
        GETBASICINFO = this.srvCustomer.getBasicInfo(this.customerId);
      }
      Observable.zip(
        translateObs,
      //  divisionStores,
        domiciliationStores,
        preferredStores,
        COUNTRIES,
        toponyms,
        CALENDAR,
        FIELDS,
        GETBASICINFO
        )
      .subscribe(([
        resTranslate,
  //      resDivisionStores,
        resDomiciliationStores,
        resPreferredStores,
        resCountries,
        resToponyms,
        resCalendar,
        resFields,
        resBasicInfo
      ]) => {

        this.calendarTranslate = resCalendar;
        this.fields = resFields;

        if(translateObs){
          this.sex.push({label: resTranslate['customerDetail.sex_male'], value: 'M'});
          this.sex.push({label: resTranslate['customerDetail.sex_female'], value: 'F'});
          this.sex.push({label: resTranslate['customerDetail.sex_other'], value: 'A'});
        }

        let cust:mgCustomer = new mgCustomer();

        if(resBasicInfo && resBasicInfo.customerCode){
          this.basicInfo = resBasicInfo;
          cust.customerId = +this.customerId;
          cust.puntoVenditaPref = this.basicInfo.preferred_store_id ? this.basicInfo.preferred_store_id.toString() : "";
          cust.nome = this.basicInfo.name;
          cust.cognome = this.basicInfo.surname;
          cust.fiscalCode = this.basicInfo.fiscal_code;
          cust.birthDate = this.basicInfo.birthday;
          cust.sex = this.basicInfo.sex;
          cust.mobile = this.basicInfo.phone_mobile;
          cust.email = this.basicInfo.email_primary;
          cust.toponym = this.basicInfo.toponym_id ? this.basicInfo.toponym_id.toString() : "";
          cust.address = this.basicInfo.address;
          cust.addressNumber = this.basicInfo.address_number;
          cust.comune = this.basicInfo.city;
          cust.zipCode = this.basicInfo.zip_code;
          cust.province = this.basicInfo.province_id;
          cust.flgAuth1 = this.basicInfo.flag_privacy;
          cust.flgAuth2 = this.basicInfo.flag_marketing_activities;
          cust.flgAuth3 = this.basicInfo.flag_profiling;
          cust.flgAuthPush = this.basicInfo.flag_push_notifications;
        }

        for (const store of resPreferredStores) {
          this.preferredStores.push({
            value: store.id,
            label: store.host_code +' - ' + store.description
          });
        }

        //console.log('this.domiciliationStores ', this.domiciliationStores);
        for (const toponym of resToponyms) {
          this.toponyms.push({
            value: toponym.id,
            label: toponym.name
          });
        }

        if(this.editMode){

          /*** SOLO CASO EDIT ***/

          if(resBasicInfo && resBasicInfo.customerCode) {
              if(resCountries){
                this.country = resCountries.data[0];
                if(this.country !== null) {
                  provinces = this.srvProvince.getAll(this.country.id);
                } else {
                  provinces = this.srvProvince.getAll(-1);
                }

                provinces.subscribe(resProvinces=>{
                  if(resProvinces){
                    this.provinces.push({value: null, label: ''});
                    for (const province of resProvinces) {
                      this.provinces.push({
                        value: province.id,
                        label: province.name
                      });
                    }

                    if(this.cardInfo){
                      if(this.cardInfo && this.cardInfo.length){
                        if(this.editMode){
                          this.srvChannel.get(this.cardInfo[0].channel_id).subscribe(res=>{
                            if(res){
                              cust.cardNo = this.cardInfo[0].cardNo;

                              self.channels = [];
                              self.channels.push({
                                value: res.id,
                                label: res.channel_code + ' - ' + res.description
                              });
                              cust.channel = this.cardInfo[0].channel_id.toString();

                              let search = [
                                {key: 'cardId',value: this.cardInfo[0].cardId.toString() }
                              ];
                              var self2 =this;
                              this.srvLoyaltyCard.list(null, null, search).subscribe(resCard => {
                                if(resCard && resCard.data.length && resCard.data.length == 1) {

                                  self2.domiciliationStores = [];

                                  //Il campo store sarebbe codice + " - " + descrizione
                                  self2.domiciliationStores.push({
                                    value: resCard.data[0].store_id,
                                    label: resCard.data[0].store
                                  });

                                  cust.puntoVendita = self2.cardInfo[0].store_id.toString();
                                }


                                self2.basicInfoLoaded.emit(resBasicInfo);
                                self2.cardsInfoLoaded.emit(this.cardInfo);
                                self2.createForm(cust);

                                var self3 = this;
                                setTimeout(function(){
                                  self3.formData.controls.cardNo.setValue(self3.cardInfo[0].cardNo);
                                  self3.formData.controls.puntoVendita.setValue(resCard.data[0].store_id.toString());
                                  if(resBasicInfo){
                                    self3.formData.controls.toponym.setValue(resBasicInfo.toponym_id);
                                    self3.formData.controls.province.setValue(resBasicInfo.province_id);
                                    self3.formData.controls.puntoVenditaPref.setValue(resBasicInfo.preferred_store_id);
                                  }
                                  self.checkAllMandatoryFields();
                                },100);

                              });
                            }
                          });
                        }
                      }
                    }
                    else{
                      self.basicInfoLoaded.emit(resBasicInfo);
                      self.cardsInfoLoaded.emit(this.cardInfo);
                      self.createForm(cust);

                      var self3 = this;
                      setTimeout(function(){
                        //self3.formData.controls.cardNo.setValue(self3.cardInfo[0].cardNo);
                        //self3.formData.controls.puntoVendita.setValue(resCard.data[0].store_id.toString());
                        if(resBasicInfo){
                          self3.formData.controls.toponym.setValue(resBasicInfo.toponym_id);
                          self3.formData.controls.province.setValue(resBasicInfo.province_id);
                          self3.formData.controls.puntoVenditaPref.setValue(resBasicInfo.preferred_store_id);
                        }
                        self.checkAllMandatoryFields();
                      },100);

                    }
                  }
                });
              }
          }
        }else{

          for (const store of resDomiciliationStores) {
              this.domiciliationStores.push({
                value: store.id,
                label: store.code +' - ' + store.description
              });
          }

          /*** SOLO CASO INSERT ***/

          if(resCountries){
            this.country = resCountries.data[0];
            if(this.country !== null) {
              provinces = this.srvProvince.getAll(this.country.id);
            } else {
              provinces = this.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces=>{
              if(resProvinces){
                this.provinces.push({value: null, label: ''});
                for (const province of resProvinces) {
                  this.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }

                this.basicInfoLoaded.emit(null);
                this.cardsInfoLoaded.emit(null);
                this.createForm(null);

                var self = this;
                setTimeout(function(){
                    if(resDomiciliationStores && resDomiciliationStores.length == 1){
                      self.formData.controls.puntoVendita.setValue(resDomiciliationStores[0].id);
                    }
                    if(resBasicInfo){
                      self.formData.controls.puntoVenditaPref.setValue(resBasicInfo.preferred_store_id);
                      self.formData.controls.toponym.setValue(resBasicInfo.toponym_id);
                      self.formData.controls.province.setValue(resBasicInfo.province_id);
                    }
                },100);

              }
            });
          }
        }

      });

  }
  checkAllMandatoryFields(){
    if( this.formData.valid){
      this.allMandatoryFieldsOkLoaded.emit(true);
    }
    else{
      this.allMandatoryFieldsOkLoaded.emit(false);
    }
  }
  checkEmailOrMobile(): boolean{
    let res = true;
    if(!this.formData.controls.email.value && !this.formData.controls.mobile.value){
      this.showEmailOrMobileError = true;
      res = false;
    }
    return res;
  }
  createForm(data: mgCustomer) {

    const isNew = data == null;
    console.log('createForm data ', data);

    this.formData = this.fb.group({
      customerId:                     this.editMode ? data.customerId : null,
      puntoVendita:                   this.editMode ? data.puntoVendita : '',
      puntoVenditaPref:               this.editMode ? data.puntoVenditaPref : '',
      channel:                        this.editMode ? data.channel : '',
      cardNo:                         this.editMode ? data.cardNo : '',
      cognome:                        this.editMode ? data.cognome : '',
      nome:                           this.editMode ? data.nome : '',
      fiscalCode:                     this.editMode ? data.fiscalCode : '',
      birthDate:                      (!isNew && data.birthDate) ? [moment(data.birthDate).toDate(), KoncentroValidators.dateNotAfter(this.maxDate)] : null,
      sex:                            this.editMode ? data.sex : '',
      mobile:                         this.editMode ? data.mobile : '',
      email:                          this.editMode ? data.email : '',
      toponym:                        this.editMode ? data.toponym : '',
      address:                        this.editMode ? data.address : '',
      addressNumber:                  this.editMode ? data.addressNumber : '',
      comune:                         this.editMode ? data.comune : '',
      zipCode:                        this.editMode ? data.zipCode : '',
      province:                       this.editMode ? data.province : null,
      flgAuth1:                       this.editMode ? data.flgAuth1 === '1' : true, //di default è uguale a true
      flgAuth2:                       this.editMode ? data.flgAuth2 === '1'  : false,
      flgAuth3:                       this.editMode ? data.flgAuth3 === '1' : false,
      flgAuthPush:                    this.editMode ? data.flgAuthPush === '1' : false,
      checkFiscalDataExistence:       true
    });

    var self = this;
    setTimeout(function(){
      if(!self.editMode){
        self.autocompleteCard.focusInput();
      }
    },100);
  }

  public customSaveMg(): Observable<any> {
    console.log('customSaveMg()');
    //ulteriore controllo sul flag auth1
    if(this.formData.get("flgAuth1").value == false){
      this.formData.get("flgAuth1").setValue(null);
    }

    if (!this.formData.valid) {
      this.invalidSubmit = true;
      return Observable.of(false);
    }

    if(this.checkEmailOrMobile() == false){
      this.invalidSubmit = true;
      return Observable.of(false);
    }

    this.invalidSubmit = false;

    if (!this.formData.get("customerId").value) {
      this.confirmationService.confirm({
        message: this.translate.instant('customers.errorSelectionCardHeader'),
        header: this.translate.instant('customers.errorSelectionCardMessage'),
        accept: () => {}
      });
      return;
    }

    if(this.editMode){
      return this.srvCustomer.updateMgCustomer(this.formData.value);
    }
    else{
      return this.srvCustomer.createMgCustomer(this.formData.value);
    }

  }

  fiscalCodeChange(newValue): void {
    if(this.fiscalCodeValidate(newValue)) {
      let partOfnewValue = newValue.toUpperCase().substring(6, 11);
      let yearFiscalCode = partOfnewValue.substring(0, 2);
      let now = new Date();

      /*
      * controllo introdotto perchè se ho un codice fiscale riferito ad un anno 1930
      * il new Date(01/01/30) produce una data con anno 2030
      */
      if(+yearFiscalCode > +now.getFullYear().toString().substr(2,2)){
        yearFiscalCode = "19"+yearFiscalCode;
      }

      let monthFiscalCode = partOfnewValue.substring(2, 3);
      let monthnumberFiscalCode = '00';
      switch(monthFiscalCode){
        case('A'):
          monthnumberFiscalCode = '01';
        break;
        case('B'):
          monthnumberFiscalCode = '02';
        break;
        case('C'):
          monthnumberFiscalCode = '03';
        break;
        case('D'):
          monthnumberFiscalCode = '04';
        break;
        case('E'):
          monthnumberFiscalCode = '05';
        break;
        case('H'):
          monthnumberFiscalCode = '06';
        break;
        case('L'):
          monthnumberFiscalCode = '07';
        break;
        case('M'):
          monthnumberFiscalCode = '08';
        break;
        case('P'):
          monthnumberFiscalCode = '09';
        break;
        case('R'):
          monthnumberFiscalCode = '10';
        break;
        case('S'):
          monthnumberFiscalCode = '11';
        break;
        case('T'):
          monthnumberFiscalCode = '12';
        break;
      }
      let dayFiscalCode = partOfnewValue.substring(3, 5);
      let daynumberFiscalCode = dayFiscalCode;
      if(parseInt(dayFiscalCode) > 40) {
        this.formData.controls.sex.setValue('F');
        daynumberFiscalCode = (parseInt(dayFiscalCode) - 40).toString();
      } else {
        this.formData.controls.sex.setValue('M');
      }
      let dateFromFiscalCode = monthnumberFiscalCode + '/' + daynumberFiscalCode + '/' + yearFiscalCode;
      this.fiscalCodeDate = new Date(dateFromFiscalCode);
      if (!isNaN(this.fiscalCodeDate.getTime())) {
        this.formData.controls.birthDate.setValue(this.fiscalCodeDate);
      } else {
        this.confirmationService.confirm({
          message: this.translate.instant('customerDetail.invalidCheckFiscalCode'),
          acceptLabel: 'Ok',
          rejectVisible: false
        });
        this.fiscalCodeDate = null;
        this.formData.controls.birthDate.reset();
        this.formData.controls.sex.reset();
      }

    } else {
      this.fiscalCodeDate = null;
      this.formData.controls.birthDate.reset();
      this.formData.controls.sex.reset();
    }
  }

  // fiscalCodeValidate(value): boolean {
  //   if(value){
  //     let validi, i, s, set1, set2, setpari, setdisp;
  //     if( value == '' )  return false;
  //     value = value.toUpperCase();
  //     if( value.length != 16 )
  //       return false;
  //     validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  //     for( i = 0; i < 16; i++ ){
  //       if( validi.indexOf( value.charAt(i) ) == -1 )
  //         return false;
  //     }
  //     set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //     set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //     setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //     setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
  //     s = 0;
  //     for( i = 1; i <= 13; i += 2 )
  //       s += setpari.indexOf( set2.charAt( set1.indexOf( value.charAt(i) )));
  //     for( i = 0; i <= 14; i += 2 )
  //       s += setdisp.indexOf( set2.charAt( set1.indexOf( value.charAt(i) )));
  //     if( s%26 != value.charCodeAt(15)-'A'.charCodeAt(0) )
  //       return false;
  //     return true;
  //   }
  //   else{
  //     return false;
  //   }
  // }

  fiscalCodeValidate(value): boolean {
    if(value){
      if( value == '' ) return false;
      value = value.toUpperCase();
      if( value.length != 16 )
        return false;
      const regex = new RegExp(/^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/);
      return regex.test(value);
    }
    else{
      return false;
    }
  }

  codiceCartaChange(newValue): void {
    //SOLO IN FASE DI INSERT PERCHE' NON PUO' ESSERE CAMBIATO IN FASE DI EDIT
    if(!this.editMode){
      if(newValue === null && (!newValue.value || newValue.value=="")) {
        this.channels = [];
        this.formData.controls.channel.reset();
        this.formData.controls.puntoVendita.reset();
      } else {
        let search = [
          {key: 'cardId',value: newValue.value },
          {key: 'addCustomerCard',value: true } //fix necessaria per non creare ulteriore chiamata clone della getCardList.
          //il parametro è stato aggiunto perchè nella ricerca della carta, per l'add di un nuovo cliente in gabrielli,
          //la nuova logica degli affiliati non faceva popolare correttamente il CANALE loyalty andando ad applicare il filtro AFFILIATO
          //ovviamente c'è il check anche lato MS.LOYALTY
        ];

        this.srvLoyaltyCard.list(null, null, search).subscribe(res => {

          if(res && res.data && res.data.length && res.data.length == 1){

            this.cardIdSelected = newValue.value;
            this.cardNoSelected = res.data[0].card_no;

            this.channels.push({
              value: res.data[0].channel_id,
              label: res.data[0].channelCode + ' - ' + res.data[0].channelDescription
            });
            this.formData.controls.channel.setValue(this.channels[0].value);
            let index = this.availableCards.findIndex(x=>x.cardId == this.cardIdSelected);
            if(index>-1){
              this.formData.controls.customerId.setValue(this.availableCards[index].customerId);
            }


            //Questo è il punto vendita trovato nella carta, ma è commentato perchè non ci devo far nulla in fase di inserimento
            //this.formData.controls.puntoVendita.setValue(res.data[0].store_id);
          }
        });
      }
    }

  }
  puntoVenditaChange(newValue):void {
    //SOLO IN FASE DI INSERT PERCHE' NON PUO' ESSERE CAMBIATO IN FASE DI EDIT
    if(!this.editMode){
      if(newValue === null && (!newValue || newValue =="")) {
        this.storeIdSelected = 0;
      }else{
        this.storeIdSelected = newValue;
      }
      this.formData.controls.puntoVenditaPref.reset();
      this.formData.controls.puntoVenditaPref.setValue(newValue);
    }
  }
  filterCardSingle(event){
    if(event && event.query && event.query.length>0){
      this.srvCustomerCard.getAvailableCards(event.query).subscribe(res=>{
        if(res){
          this.availableCards = res;
          this.code_cards = [{value: null, label: ''}];
          for (const codeCard of res) {
            if(codeCard.flagBlackList != "1"){
              this.code_cards.push({
                value: codeCard.cardId,
                label: codeCard.cardNo
              });
            }
          }
        }
      });
    }
  }
  onClickDropdownCarta(event){
    this.code_cards = [];
      this.srvCustomerCard.getAvailableCards(event.query).subscribe(res=>{
        this.availableCards = res;
        this.code_cards = [{value: null, label: ''}];
        for (const codeCard of res) {
          if(codeCard.flagBlackList != "1"){
            this.code_cards.push({
              value: codeCard.cardId,
              label: codeCard.cardNo + ' (' + codeCard.cardType + ')'
            });
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/basicinfonew/basicnew.component.ts